// Center-screen "FIGHT!" banner shown at the start of every round, plus
// one-shot SFX helpers for round-start and game win/loss. The banner mounts
// briefly on document.body, scales+fades in/holds/scales+fades out, and
// removes itself. Audio uses the same lightweight cloneNode pattern as
// RoundEndModal — no FxBus involvement; these are flat 2D UI sounds.

import { t } from '../i18n';

const ROUND_START_SFX = '/sounds/round-start.ogg';
const WIN_SFX = '/sounds/win.ogg';
const LOSS_SFX = '/sounds/loss.ogg';

const FADE_IN_MS = 220;
const HOLD_MS = 650;
const FADE_OUT_MS = 320;

const sfxCache = new Map<string, HTMLAudioElement>();
function playSfx(src: string): void {
  try {
    let base = sfxCache.get(src);
    if (!base) {
      base = new Audio(src);
      sfxCache.set(src, base);
    }
    const a = base.cloneNode(true) as HTMLAudioElement;
    a.volume = 0.9;
    void a.play().catch(() => { /* autoplay block — ignore */ });
  } catch { /* best-effort */ }
}

let stylesEnsured = false;
function ensureStyles(): void {
  if (stylesEnsured) return;
  stylesEnsured = true;
  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Chewy&display=swap');
  `;
  document.head.appendChild(style);
}

export function showFightBanner(): void {
  ensureStyles();
  playSfx(ROUND_START_SFX);

  const el = document.createElement('div');
  el.textContent = t('roundStart.fight');
  el.style.cssText = [
    'position: fixed',
    'left: 50%',
    'top: 38%',
    'transform: translate(-50%, -50%) scale(0.5)',
    'color: #ffffff',
    "font-family: 'Chewy', ui-sans-serif, system-ui, sans-serif",
    'font-size: clamp(72px, 12vw, 180px)',
    'font-weight: 400',
    'line-height: 1',
    'text-shadow: 0 0 18px rgba(0, 0, 0, 0.85), 0 0 36px rgba(0, 0, 0, 0.6)',
    'opacity: 0',
    `transition: opacity ${FADE_IN_MS}ms cubic-bezier(0.2, 0.9, 0.3, 1.2), transform ${FADE_IN_MS}ms cubic-bezier(0.2, 0.9, 0.3, 1.2)`,
    'pointer-events: none',
    'user-select: none',
    'z-index: 1500',
    'white-space: nowrap'
  ].join('; ');
  document.body.appendChild(el);

  // Two rAFs so the initial styles paint before the transition kicks in.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translate(-50%, -50%) scale(1)';
    });
  });

  window.setTimeout(() => {
    el.style.transition = `opacity ${FADE_OUT_MS}ms ease-in, transform ${FADE_OUT_MS}ms ease-in`;
    el.style.opacity = '0';
    el.style.transform = 'translate(-50%, -50%) scale(1.6)';
    window.setTimeout(() => el.remove(), FADE_OUT_MS + 40);
  }, FADE_IN_MS + HOLD_MS);
}

export function playGameEndSfx(localWon: boolean): void {
  playSfx(localWon ? WIN_SFX : LOSS_SFX);
}
